import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _07a87587 = () => interopDefault(import('../../../pages/App.vue' /* webpackChunkName: "pages/App" */))
const _0faef30f = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _aa62f3ac = () => interopDefault(import('../../../pages/Cart.vue' /* webpackChunkName: "pages/Cart" */))
const _6badb106 = () => interopDefault(import('../../../pages/Contact.vue' /* webpackChunkName: "pages/Contact" */))
const _0547af50 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _02985692 = () => interopDefault(import('../../../pages/Download.vue' /* webpackChunkName: "pages/Download" */))
const _765e6d9f = () => interopDefault(import('../../../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _1afa32c6 = () => interopDefault(import('../../../pages/fast-checkout.vue' /* webpackChunkName: "pages/fast-checkout" */))
const _f08ecf26 = () => interopDefault(import('../../../pages/foodprint-calculator/index.vue' /* webpackChunkName: "pages/foodprint-calculator/index" */))
const _4eafc28f = () => interopDefault(import('../../../pages/Klarna.vue' /* webpackChunkName: "pages/Klarna" */))
const _5999ea0e = () => interopDefault(import('../../../pages/NotFound.vue' /* webpackChunkName: "pages/NotFound" */))
const _1a666c3e = () => interopDefault(import('../../../pages/Play.vue' /* webpackChunkName: "pages/Play" */))
const _4aab2afa = () => interopDefault(import('../../../pages/PrivacyApp.vue' /* webpackChunkName: "pages/PrivacyApp" */))
const _7d0ae3b6 = () => interopDefault(import('../../../pages/Research.vue' /* webpackChunkName: "pages/Research" */))
const _fa4e57e2 = () => interopDefault(import('../../../pages/shelfy-secret-perk-direct.vue' /* webpackChunkName: "pages/shelfy-secret-perk-direct" */))
const _73262d70 = () => interopDefault(import('../../../pages/spare-parts.vue' /* webpackChunkName: "pages/spare-parts" */))
const _09c978c7 = () => interopDefault(import('../../../pages/Store.vue' /* webpackChunkName: "pages/Store" */))
const _0ae34edb = () => interopDefault(import('../../../pages/Story.vue' /* webpackChunkName: "pages/Story" */))
const _6305d3e6 = () => interopDefault(import('../../../pages/Suppliers.vue' /* webpackChunkName: "pages/Suppliers" */))
const _46f666e7 = () => interopDefault(import('../../../pages/Team.vue' /* webpackChunkName: "pages/Team" */))
const _37ad231b = () => interopDefault(import('../../../pages/Careers.vue' /* webpackChunkName: "pages/Careers" */))
const _31230fe3 = () => interopDefault(import('../../../pages/account/product-registration.vue' /* webpackChunkName: "pages/account/product-registration" */))
const _dc236f8a = () => interopDefault(import('../../../pages/blog/search.vue' /* webpackChunkName: "pages/blog/search" */))
const _6dab429b = () => interopDefault(import('../../../pages/download/shelfy-user-guide.vue' /* webpackChunkName: "pages/download/shelfy-user-guide" */))
const _55f8290c = () => interopDefault(import('../../../pages/referral/dashboard.vue' /* webpackChunkName: "pages/referral/dashboard" */))
const _3bec1ea1 = () => interopDefault(import('../../../pages/shelfy/onboarding.vue' /* webpackChunkName: "pages/shelfy/onboarding" */))
const _950d68c6 = () => interopDefault(import('../../../pages/blog/_category/index.vue' /* webpackChunkName: "pages/blog/_category/index" */))
const _4094ff36 = () => interopDefault(import('../../../pages/faq/_product/index.vue' /* webpackChunkName: "pages/faq/_product/index" */))
const _6b989d08 = () => interopDefault(import('../../../pages/foodprint-calculator/_score.vue' /* webpackChunkName: "pages/foodprint-calculator/_score" */))
const _58edda16 = () => interopDefault(import('../../../pages/blog/_category/_uid.vue' /* webpackChunkName: "pages/blog/_category/_uid" */))
const _597f7df5 = () => interopDefault(import('../../../pages/faq/_product/_section/index.vue' /* webpackChunkName: "pages/faq/_product/_section/index" */))
const _2cabfcbe = () => interopDefault(import('../../../pages/faq/_product/_section/_uid.vue' /* webpackChunkName: "pages/faq/_product/_section/_uid" */))
const _192ef9fb = () => interopDefault(import('../../../pages/_uid.vue' /* webpackChunkName: "pages/_uid" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior,

  routes: [{
    path: "/app",
    component: _07a87587,
    name: "App___en"
  }, {
    path: "/blog",
    component: _0faef30f,
    name: "blog___en"
  }, {
    path: "/cart",
    component: _aa62f3ac,
    name: "Cart___en"
  }, {
    path: "/contact",
    component: _6badb106,
    name: "Contact___en"
  }, {
    path: "/de",
    component: _0547af50,
    name: "index___de"
  }, {
    path: "/download",
    component: _02985692,
    name: "Download___en"
  }, {
    path: "/faq",
    component: _765e6d9f,
    name: "faq___en"
  }, {
    path: "/fast-checkout",
    component: _1afa32c6,
    name: "fast-checkout___en"
  }, {
    path: "/foodprint-calculator",
    component: _f08ecf26,
    name: "foodprint-calculator___en"
  }, {
    path: "/it",
    component: _0547af50,
    name: "index___it"
  }, {
    path: "/klarna",
    component: _4eafc28f,
    name: "Klarna___en"
  }, {
    path: "/not-found",
    component: _5999ea0e,
    name: "NotFound___en"
  }, {
    path: "/Play",
    component: _1a666c3e,
    name: "Play___en"
  }, {
    path: "/privacy-app",
    component: _4aab2afa,
    name: "PrivacyApp___en"
  }, {
    path: "/research",
    component: _7d0ae3b6,
    name: "Research___en"
  }, {
    path: "/shelfy-secret-perk-direct",
    component: _fa4e57e2,
    name: "shelfy-secret-perk-direct___en"
  }, {
    path: "/spare-parts",
    component: _73262d70,
    name: "spare-parts___en"
  }, {
    path: "/stores",
    component: _09c978c7,
    name: "Store___en"
  }, {
    path: "/story",
    component: _0ae34edb,
    name: "Story___en"
  }, {
    path: "/suppliers",
    component: _6305d3e6,
    name: "Suppliers___en"
  }, {
    path: "/team",
    component: _46f666e7,
    name: "Team___en"
  }, {
    path: "/work-with-us",
    component: _37ad231b,
    name: "Careers___en"
  }, {
    path: "/account/product-registration",
    component: _31230fe3,
    name: "account-product-registration___en"
  }, {
    path: "/blog/search",
    component: _dc236f8a,
    name: "blog-search___en"
  }, {
    path: "/de/app",
    component: _07a87587,
    name: "App___de"
  }, {
    path: "/de/blog",
    component: _0faef30f,
    name: "blog___de"
  }, {
    path: "/de/cart",
    component: _aa62f3ac,
    name: "Cart___de"
  }, {
    path: "/de/download",
    component: _02985692,
    name: "Download___de"
  }, {
    path: "/de/faq",
    component: _765e6d9f,
    name: "faq___de"
  }, {
    path: "/de/fast-checkout",
    component: _1afa32c6,
    name: "fast-checkout___de"
  }, {
    path: "/de/foodprint-calculator",
    component: _f08ecf26,
    name: "foodprint-calculator___de"
  }, {
    path: "/de/forschen",
    component: _7d0ae3b6,
    name: "Research___de"
  }, {
    path: "/de/geschaefte",
    component: _09c978c7,
    name: "Store___de"
  }, {
    path: "/de/geschichte",
    component: _0ae34edb,
    name: "Story___de"
  }, {
    path: "/de/karriere",
    component: _37ad231b,
    name: "Careers___de"
  }, {
    path: "/de/klarna",
    component: _4eafc28f,
    name: "Klarna___de"
  }, {
    path: "/de/kontakt",
    component: _6badb106,
    name: "Contact___de"
  }, {
    path: "/de/lieferanten",
    component: _6305d3e6,
    name: "Suppliers___de"
  }, {
    path: "/de/not-found",
    component: _5999ea0e,
    name: "NotFound___de"
  }, {
    path: "/de/Play",
    component: _1a666c3e,
    name: "Play___de"
  }, {
    path: "/de/privacy-app",
    component: _4aab2afa,
    name: "PrivacyApp___de"
  }, {
    path: "/de/shelfy-secret-perk-direct",
    component: _fa4e57e2,
    name: "shelfy-secret-perk-direct___de"
  }, {
    path: "/de/spare-parts",
    component: _73262d70,
    name: "spare-parts___de"
  }, {
    path: "/de/team",
    component: _46f666e7,
    name: "Team___de"
  }, {
    path: "/download/shelfy-user-guide",
    component: _6dab429b,
    name: "download-shelfy-user-guide___en"
  }, {
    path: "/it/app",
    component: _07a87587,
    name: "App___it"
  }, {
    path: "/it/blog",
    component: _0faef30f,
    name: "blog___it"
  }, {
    path: "/it/carrello",
    component: _aa62f3ac,
    name: "Cart___it"
  }, {
    path: "/it/contatti",
    component: _6badb106,
    name: "Contact___it"
  }, {
    path: "/it/download",
    component: _02985692,
    name: "Download___it"
  }, {
    path: "/it/faq",
    component: _765e6d9f,
    name: "faq___it"
  }, {
    path: "/it/fast-checkout",
    component: _1afa32c6,
    name: "fast-checkout___it"
  }, {
    path: "/it/foodprint-calculator",
    component: _f08ecf26,
    name: "foodprint-calculator___it"
  }, {
    path: "/it/fornitori",
    component: _6305d3e6,
    name: "Suppliers___it"
  }, {
    path: "/it/klarna",
    component: _4eafc28f,
    name: "Klarna___it"
  }, {
    path: "/it/lavora-con-noi",
    component: _37ad231b,
    name: "Careers___it"
  }, {
    path: "/it/negozi",
    component: _09c978c7,
    name: "Store___it"
  }, {
    path: "/it/not-found",
    component: _5999ea0e,
    name: "NotFound___it"
  }, {
    path: "/it/Play",
    component: _1a666c3e,
    name: "Play___it"
  }, {
    path: "/it/privacy-app",
    component: _4aab2afa,
    name: "PrivacyApp___it"
  }, {
    path: "/it/ricambi",
    component: _73262d70,
    name: "spare-parts___it"
  }, {
    path: "/it/ricerche",
    component: _7d0ae3b6,
    name: "Research___it"
  }, {
    path: "/it/shelfy-secret-perk-direct",
    component: _fa4e57e2,
    name: "shelfy-secret-perk-direct___it"
  }, {
    path: "/it/storia",
    component: _0ae34edb,
    name: "Story___it"
  }, {
    path: "/it/team",
    component: _46f666e7,
    name: "Team___it"
  }, {
    path: "/referral/dashboard",
    component: _55f8290c,
    name: "referral-dashboard___en"
  }, {
    path: "/shelfy/onboarding",
    component: _3bec1ea1,
    name: "shelfy-onboarding___en"
  }, {
    path: "/de/account/product-registration",
    component: _31230fe3,
    name: "account-product-registration___de"
  }, {
    path: "/de/blog/suche",
    component: _dc236f8a,
    name: "blog-search___de"
  }, {
    path: "/de/download/shelfy-user-guide",
    component: _6dab429b,
    name: "download-shelfy-user-guide___de"
  }, {
    path: "/de/referral/dashboard",
    component: _55f8290c,
    name: "referral-dashboard___de"
  }, {
    path: "/de/shelfy/onboarding",
    component: _3bec1ea1,
    name: "shelfy-onboarding___de"
  }, {
    path: "/it/account/product-registration",
    component: _31230fe3,
    name: "account-product-registration___it"
  }, {
    path: "/it/blog/cerca",
    component: _dc236f8a,
    name: "blog-search___it"
  }, {
    path: "/it/download/shelfy-user-guide",
    component: _6dab429b,
    name: "download-shelfy-user-guide___it"
  }, {
    path: "/it/referral/dashboard",
    component: _55f8290c,
    name: "referral-dashboard___it"
  }, {
    path: "/it/shelfy/onboarding",
    component: _3bec1ea1,
    name: "shelfy-onboarding___it"
  }, {
    path: "/",
    component: _0547af50,
    name: "index___en"
  }, {
    path: "/de/blog/:category",
    component: _950d68c6,
    name: "blog-category___de"
  }, {
    path: "/de/faq/:product",
    component: _4094ff36,
    name: "faq-product___de"
  }, {
    path: "/de/foodprint-calculator/:score?",
    component: _6b989d08,
    name: "foodprint-calculator-score___de"
  }, {
    path: "/it/blog/:category",
    component: _950d68c6,
    name: "blog-category___it"
  }, {
    path: "/it/faq/:product",
    component: _4094ff36,
    name: "faq-product___it"
  }, {
    path: "/it/foodprint-calculator/:score?",
    component: _6b989d08,
    name: "foodprint-calculator-score___it"
  }, {
    path: "/de/blog/:category/:uid",
    component: _58edda16,
    name: "blog-category-uid___de"
  }, {
    path: "/de/faq/:product/:section",
    component: _597f7df5,
    name: "faq-product-section___de"
  }, {
    path: "/it/blog/:category/:uid",
    component: _58edda16,
    name: "blog-category-uid___it"
  }, {
    path: "/it/faq/:product/:section",
    component: _597f7df5,
    name: "faq-product-section___it"
  }, {
    path: "/de/faq/:product/:section/:uid",
    component: _2cabfcbe,
    name: "faq-product-section-uid___de"
  }, {
    path: "/it/faq/:product/:section/:uid",
    component: _2cabfcbe,
    name: "faq-product-section-uid___it"
  }, {
    path: "/blog/:category",
    component: _950d68c6,
    name: "blog-category___en"
  }, {
    path: "/de/:uid",
    component: _192ef9fb,
    name: "uid___de"
  }, {
    path: "/faq/:product",
    component: _4094ff36,
    name: "faq-product___en"
  }, {
    path: "/foodprint-calculator/:score?",
    component: _6b989d08,
    name: "foodprint-calculator-score___en"
  }, {
    path: "/it/:uid",
    component: _192ef9fb,
    name: "uid___it"
  }, {
    path: "/blog/:category/:uid",
    component: _58edda16,
    name: "blog-category-uid___en"
  }, {
    path: "/faq/:product/:section",
    component: _597f7df5,
    name: "faq-product-section___en"
  }, {
    path: "/faq/:product/:section/:uid",
    component: _2cabfcbe,
    name: "faq-product-section-uid___en"
  }, {
    path: "/:uid",
    component: _192ef9fb,
    name: "uid___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
